/* Testo Coffee free gifts: keeps $0 gift lines in the cart in step with the bundle(s) in it. */
(function () {
  var cfg = window.TESTO_GIFTS;
  if (!cfg || !cfg.gifts || !cfg.gifts.length) return;
  var chain = Promise.resolve();
  var rawFetch = window.fetch.bind(window);
  var JSON_HEAD = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

  function pouches(items) {
    var n = 0;
    items.forEach(function (i) { var p = cfg.bundles[String(i.variant_id)]; if (p) n += p * i.quantity; });
    return n;
  }
  function getCart() { return rawFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  // Returns a promise resolving true when the cart was changed.
  function apply(cart, extra) {
    var total = pouches(cart.items) + (extra || 0);
    var add = [], upd = {}, changed = false;
    cfg.gifts.forEach(function (g) {
      var line = null;
      cart.items.forEach(function (i) { if (i.variant_id === g.v) line = i; });
      var want = total >= g.min ? 1 : 0;
      if (want && !line) add.push({ id: g.v, quantity: 1, properties: { _testo_gift: '1' } });
      else if (!want && line) upd[g.v] = 0;
      else if (want && line && line.quantity !== 1) upd[g.v] = 1;
    });
    var p = Promise.resolve();
    if (add.length) p = p.then(function () { changed = true; return rawFetch('/cart/add.js', { method: 'POST', headers: JSON_HEAD, body: JSON.stringify({ items: add }) }); });
    if (Object.keys(upd).length) p = p.then(function () { changed = true; return rawFetch('/cart/update.js', { method: 'POST', headers: JSON_HEAD, body: JSON.stringify({ updates: upd }) }); });
    return p.then(function () { return changed; });
  }
  function sync(extra) {
    var run = function () { return getCart().then(function (c) { return apply(c, extra); }).catch(function () { return false; }); };
    chain = chain.then(run, run);
    return chain;
  }
  function refreshDrawer() {
    // Prefer the theme's own drawer updater (works on every theme version); fall back to the cart-update event.
    rawFetch('/cart?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (t) {
      var html = new DOMParser().parseFromString(t, 'text/html');
      var fresh = html.querySelector('#CartDrawer'), host = document.querySelector('cart-drawer');
      if (fresh && host && typeof window.updateCartDrawer === 'function') window.updateCartDrawer(host, fresh);
      else if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'testo-gifts' });
    }).catch(function () {
      if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'testo-gifts' });
    });
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () { sync().then(function (ch) { if (ch) refreshDrawer(); }); }, 350);
  }

  function init() {
    // 1. On load: fix any drift (for example a gift left in the cart after the bundle was removed)
    sync().then(function (ch) { if (ch) refreshDrawer(); });

    // 2. Any cart change made through the theme (qty, remove, add). Watching the requests themselves
    //    works on every theme version, whether or not it publishes a cart-update event.
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = rawFetch.apply(window, arguments);
      if (/\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url)) { p.then(schedule, function () {}); }
      return p;
    };
    if (window.subscribe && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (ev && ev.source === 'testo-gifts') return;
        schedule();
      });
    }

    // 3. Add-to-cart on a Testo bundle: add the gifts first so the drawer opens with them already in
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.matches || !f.matches('form[data-type="add-to-cart-form"]')) return;
      var idEl = f.querySelector('input[name="id"]'); if (!idEl) return;
      var bundle = cfg.bundles[String(idEl.value)];
      if (!bundle) return;
      if (f.dataset.giftsReady === '1') { f.dataset.giftsReady = '0'; return; }
      e.preventDefault(); e.stopImmediatePropagation();
      var qEl = f.querySelector('input[name="quantity"]');
      var extra = bundle * (parseInt(qEl && qEl.value, 10) || 1);
      sync(extra).then(function () { f.dataset.giftsReady = '1'; f.requestSubmit(); });
    }, true);
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
